import React, { Component } from 'react'
import { Modal, FormGroup, ControlLabel, Row, Col } from 'react-bootstrap'
import NkaButton from 'nka-button'
import Datetime from 'react-datetime'
import moment from 'moment'
import 'moment/locale/nb'

import 'react-datetime/css/react-datetime.css'
import 'nka-button/dist/style.css'

export default class EndreTidspunkt extends Component {
    constructor() {
        super()
        this.state = {
            dato: null,
            oppdaterMaalere: false
        }

        this._submit = this._submit.bind(this)
        this._handleEndret = this._handleEndret.bind(this)
        this._handleOppdatereAlleMaalere = this._handleOppdatereAlleMaalere.bind(this)
    }

    componentDidMount() {}

    _submit() {
        let datoOk = moment(this.state.dato).isValid()

        if (!datoOk) {
            alert('Ugyldig format på dato, bruk datovelgeren')
        } else {
            this.props.onEndreTidspunt(this.state.dato, this.state.oppdaterMaalere)
        }
    }

    _handleEndret(datoFraKalender) {
        var nyDato = new Date(datoFraKalender)
        this.setState({
            dato: moment(nyDato).format('YYYY-MM-DDTHH:mm:00')
        })
    }

    _handleOppdatereAlleMaalere(event) {
        this.setState({
            oppdaterMaalere: event.target.checked
        })
    }

    render() {
        var startTidspunt = Datetime.moment(this.props.avtaltdato)

        var valid = function(current) {
            return (
                current.isSameOrAfter(startTidspunt) && current.day() !== 0 && current.day() !== 6
            )
        }

        return (
            <Modal show={this.props.isOpen} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Endre tidspunkt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <ControlLabel>Tidspunkt</ControlLabel>
                                <Datetime
                                    isValidDate={valid}
                                    timeConstraints={{ hours: { min: 6 } }}
                                    defaultValue={startTidspunt}
                                    onChange={this._handleEndret}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <input
                                    type="checkbox"
                                    onChange={this._handleOppdatereAlleMaalere}
                                />
                                <span className="checkboxtext">
                                    Oppdater tidspunkt for alle etterfølgende målere
                                </span>
                            </FormGroup>
                        </Col>
                    </Row>
                    <NkaButton onClick={this._submit} buttontype="primary">Ok</NkaButton>
                </Modal.Body>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/endreTidspunktModal.jsx